export default {
    radio: {
        radio: "Radio",
        day: "Day",
        unknown: "Unknown",
        current: "Current",
        target: "Target",
        bulkTuningCounts: "Tuning Radio Distribution",
        bulkTuningCountsGraphLabel: "Radio Counts",
        trafficType: "Traffic Type",
        trafficTypes: {
            BOOST: "Boost",
            BULK: "Bulk",
            BUDDY: "Buddy",
            DOWNLINK: "Downlink",
            L2ACK_1: "L2ACK 1",
            L2ACK_2: "L2ACK 2",
            L2ACK_3: "L2ACK 3",
            POLL_RESPONSE: "Poll/Response",
            PRIORITY: "Priority",
            RTS: "RTS",
            UPLINK: "Uplink",
        },
        metricsNav: "Metrics",
        metricsList: "Radio List",
        metricsDashboard: "Radio Dashboard",
        tuningNav: "Tuning",
        tuningConfig: "Tuning Configuration",
        tuningResults: "Tuning Results",
        tuningCompare: "Tuning Result Comparison",
        tuningJson: "Tuning JSON",
        pendingTuningChanges: "Pending Tuning Changes",
        rapidTuning: "Rapid Tuning",
        channelNav: "Channels",
        buddyNav: "Buddies",
        activeCommands: "Active Commands",
        channelConfig: "Channel Configuration",
        channelResults: "Channel Results",
        buddyConfig: "Buddy Configuration",
        buddyResults: "Buddy Results",
        ipEnabled: "IP Enabled",
        tuningOption: "Subsequent Tuning Actions",
        encrypted: "Encrypted",
        builtInDashboards: {
            baseEndpointConfiguration: "NCS: Base Endpoint Configuration",
            transmitReceiveConfiguration: 'NCS: Transmit/Receive Configuration',
            frequencyConfiguration: 'NCS: Frequency Configuration',
            tuningGroupCounts: 'NCS: Tuning Group Counts'
        },
        buddy: {
            vitalBuddyCurrent: "Current (Vital Buddy and Repeat Enabled)",
            vitalBuddyMovingIn: "Promote (Vital Buddy and missing Repeat Enabled)",
            vitalBuddyMovingOut: "Demote (Not Vital Buddy and Repeat Enabled)",
            isSOSBuddy: "SOS Buddy",
            isVitalBuddy: "Vital Buddy",
            vitalBuddyTargetState: "Vital Buddy Target State",
            vitalBuddyTargetStates: {
                PROMOTE_TO: "Promote",
                DEMOTE_FROM: "Demote",
                null: "Not Set",
            },
            srbCurrent: "Current (Vital Buddy and Static Rebroadcaster Enabled)",
            srbMovingIn: "Promote (Vital Buddy and Static Rebroadcaster Targeted to be Enabled)",
            srbMovingOut: "Demote (Vital Buddy and Static Rebroadcaster targeted to be Disabled)",
            inBuddySupportDownlinkChannel: "Buddy Support Downlink Channel",
            mPassBuddyRepeatEnabled: 'mPass Buddy Repeat',
            mPassBuddyRepeatEnabledTarget: 'mPass Buddy Repeat Target',
            buddyConfigChangeStartTime: 'Buddy Config Change Start Time',
            staticRebroadcasterTargetState: "Static Rebroadcaster Target State",
            staticRebroadcasterTargetStateNames: {
                PROMOTE_TO: "Promote",
                DEMOTE_FROM: "Demote",
                null: "Not Set"
            },
            forwardMode: "Buddy Forward Mode",
            forwardModes: {
                C_AND_I: "C & I",
                DEFAULT: "Default",
                null: "Not Set"
            },
            messageMode: "Buddy Message Mode",
            messageModes: {
                SEND_1_OF_8: "Send 1 of 8",
                SEND_1_OF_16: "Send 1 of 16",
                SEND_ALL: "Send All",
                SEND_NONE: "Send None",
                null: "Not Set"
            },
            randomQueueTime: "Randomly Assign Buddy Queue Time"
        },
        rssiDistributeThreshold: "RSSI Distribute Threshold (dB)",
        cmdDisabled: "Command processing for Radios is disabled",
        cmdEnabled: "Command processing for Radios is enabled",
        config: {
            caTab: "Channel Allocation",
            carTab: "Channel Allocation Results",
            ragTab: "Special Condition Config",
            ragrTab: "Special Condition Results",
            tcTab: "Tuning Config",
            thTab: "Tuning Group Results",
            bcTab: "Buddy Config",
            bchTab: "Buddy Config Results",
            rtTab: 'Rapid Tuning',
            acTab: 'Active Commands'
        },
        sosBuddyRepId: 'SOS Buddy Rep Id',
        sosOrdRepId: 'SOS ORD Rep Id',
        mPassBuddyRepeatEnabled: 'mPass Buddy Repeat',
        buddySupportState: "Buddy Support State",
        buddySupportStateTitle: 'Buddy Support State',
        buddySupportStateNames: {
            NORMAL: "Disabled",
            BUDDY: "Buddy",
            STATIC_REBROADCASTER: "Static Rebroadcaster",
            ORD: "Out of Reach Device",
            null: "Not Set"
        },
        sourceId: 'Source ID',
        currentChannelPair: "Current Channel Pair",
        previousChannelPair: "Previous Channel Pair",
        channelPairIndex: "Channel Pair Index",
        targetBulkChannelPair: "Target Bulk Channel Pair",
        networkPlanNotSet: "Not in Network Plan",
        targetUplinkFreq: "Target Uplink Frequency",
        targetDownlinkFreq: "Target Downlink Frequency",
        configCommsHub: "Setup Comms Hub",
        configFNv1: "Setup FNv1 Radio",
        configFNv2: "Setup FNv2 Radio",
        activeAlarmCount: 'Active Alarm',
        threshold: "Threshold",
        noDevices: "No devices for this radio",
        radioEndpoints: "Radio Endpoints",
        deleteRadios: "Delete Radios",
        deleteRadiosPrompt: 'Are you sure you want to delete the radios in the file {fileName}?',
        deleteRadiosWithInvalidIds: 'The following ids in the file were not valid and were ignored: {ids}',
        deleteRadiosAsync: 'Delete request for radios submitted. Go to History to view the command status.',
        deleteRadiosInvalidFile: 'Uploaded Invalid File',
        deleteRadiosInvalidFileSize: 'Uploaded Invalid File, a maximum of 5000 radios can be deleted at a time',
        deleteRadiosError: 'Error deleting radios',
        id: "Radio ID",
        repId: "Radio ID",
        radioId: "Radio ID",
        fqdn: "FQDN",
        deviceType: "Device Type",
        radioType: "Radio Type",
        deviceTypeCategories: "Device Type Categories",
        deviceTypeFirmware: "Firmware by Device Type",
        deviceTypeFirmwareTitle: 'Firmware by Device Type',
        deviceTypeFirmwareGraphLabel: "Endpoints",
        encryption: "Encryption",
        selectSync: "Synchronize Radios",
        syncAll:"Sync All Radios",
        syncUpdated:"Sync Updated Radios",
        syncRadio: "Sync",
        cancel: "Cancel",
        name: "Name",
        zipCode: "Zip Code",
        postalCode: "Postal Code",
        city: "City",
        sets: "Sets",
        latlong: "Lat/Long",
        latlongCalc: "Lat/Long (Estimated)",
        activeAlarms: "Active Alarms",
        mptLastHeard: "MPT Last Heard",
        lastImportDate:"Last RNI Import Change",
        mptPercentYesterday: "MPT % Yesterday",
        esmReadsYesterday: "ESM Reads Yesterday",
        esmSnapshotCountYesterday: "Snapshots per Read",
        lastHeard: "Last Heard",
        lastHeardDuration: "Last Heard",
        lastHeardDurationFilterName: "Last Heard Duration",
        lastHeardNotSet: "Has Been Heard",
        lastHeard30DaysStale: "Last Heard More Than 30 Days Ago",
        newlyHeardDuration: "Newly Heard",
        lastSetupMsg: "Last Setup Message Heard",
        installDate: "Install Date",
        fwdlEndDate: {
            displayString: "Firmware Download Date",
            duration: "Firmware Download Status",
            isInProgress: "In Progress",
            notInProgress: "Not In Progress",
        },
        fwdlInProgress: "Firmware Download Status",
        discovered: "System Discovered",
        firstHeard: "First Heard",
        firstHeardRni: 'First Heard by RNI',
        firstHeardNcs: 'First Heard by NCS',
        rxOpMode: "Receiver Operational Mode",
        rxOpModeTarget: "Tuning Receiver Operational Mode Target",
        transmitOperationalMode: "Transmitter Operational Mode",
        transmitOperationalModeTarget: "Tuning Transmitter Operational Mode Targets",
        pingMenu: 'Ping',
        sendPingForSetup: "Ping for Static Setup",
        sendPingIP6: {
            action: "Ping IP",
            queued: "IP ping initiated. Please wait for results...",
            error: "The IP ping failed"
        },
        sendPingForAdvancedSetup: "Ping for Advanced Setup",
        sendPingForESMMetadataSetup: "Ping for ESM Metadata",
        sendPingForESMConfigSetup: "Ping for ESM Config",
        sendPingForOrdReport: "Ping for ORD Report",
        sendPingForTowerSignalStrengthReport: "Ping for Base Station Signal Strength Report",
        sendAlarmsOnPriorityChannel: "Send Alarms On Priority Channel",
        pingBaseMsg: "{pingType} sent for selected radios.",
        pingBaseMsg2: "For more information and to track the progress see ",
        pingForTime: "Ping for Time",
        pingSentErrorMsg: "Errors sending Ping {pingType} command to selected radios, see log",
        changeTuneState: "Change Tuning State",
        steupTuning: "Setup Tuning State",
        sendMenu: 'Send',
        sendSetup: "Send Setup Command",
        sendTargetCommandsToSelected: "Send Targets to Selected",
        sendTargetCommandsToSet: "Send Targets to Set",
        setupSendConfirm: "Are you sure you want to change the setup?",
        setupSentMsg: "Setup command sent to selected radios",
        setupSentUnknownErrMsg: "Errors sending Setup command to selected radios, see log",
        setupSentErrMsg: "Errors sending Setup command to selected radios:  ",
        resetHysteresisForRadio: 'Reset Hysteresis',
        resetHysteresisForSelectedRadios: 'Reset Hysteresis for Selected',
        resetHysteresisForSet: 'Reset Hysteresis for Set',
        resetHysteresisForRadioSuccess: 'Hysteresis reset',
        resetHysteresisForSelectedRadiosSuccess: 'Hysteresis reset for {numRadios} radios',
        resetHysteresisForSetSuccess: 'Hysteresis reset sent for set {setName}',
        resetAnalysisDaysForRadio: 'Reset Analysis Days',
        resetAnalysisDaysForSelected: 'Reset Analysis Days for Selected',
        resetAnalysisDaysForSet: 'Reset Analysis Days for Set',
        resetAnalysisDaysForRadioSuccess: 'Analysis days reset',
        resetAnalysisDaysForSelectedSuccess: 'Analysis days reset for {numRadios} endpoints',
        resetAnalysisDaysForSetSuccess: 'Analysis days reset sent for set {setName}',
        resetAnalysisDaysFailed: 'Failed to reset analysis days',
        staticRebroadcaster: "Static Rebroadcaster",
        staticRebroadcasterConfig: "Tuning Static Rebroadcaster Targets",
        vitalBuddyConfig: "Tuning Vital Buddy Targets",
        radioNotTunable: " is not in a state to issue a setup command, try to ping the radio",
        nonTunableRepeater: 'Non Tunable Repeater',
        provenDate: 'Proven Date',
        ordToStaticRebroadcasterDistance: 'ORD To Static Rebroadcaster Distance(miles)',
        tuneMatchingRadios: "Perform Performance Optimization",
        tuneRadios: "Tune Selected Radios",
        tuningRequestMade: "Tuning selected radios",
        tuningErrorMsg: "Tune Radios error, see log",
        sendTargetsToSelectedRequestMade: 'Sending targets to {numRadios} of {numRadiosExpected} radios',
        sendTargetsToSetRequestMade: 'Sending targets to set {setName}',
        sendTargetsError: 'Error sending targets',
        detailsTitle: "Radio Details",
        general: "General",
        transmitMode: "Transmit Mode",
        transmitModeLat: "Transmit Mode LAT",
        transmitModeMom: "Transmit Mode MOM",
        transmissionMode: "Transmission Mode",
        receiveMode: "Receive Mode",
        locationStatus: "Location Status",
        commsSection: 'Communication Options',
        statsSection: 'Statistics',
        msgStatsSection: 'Statistics from Messages',
        msgStatsTT: 'Statistics calculated from messages received from the radio.',
        baseStationSection: 'Base Station Connection',
        uplinkTuningStats: "Uplink Tuning Statistics",
        uplinkTuningStatsTT: "Uplink tuning statistics calculated from daily tuning job.",
        uplinkRouteStats: "Uplink Route Statistics",
        uplinkRouteStatsTT: "Uplink route statistics calculated from daily route job.",
        downlinkRouteStats: "Downlink Route Statistics",
        downlinkRouteStatsTT: "Downlink route statistics calculated from daily route job.",
        altitude: "Altitude",
        towersHeard: "Daily Base Stations Heard",
        towersHeardIDs: "Base Stations Heard ID(s)",
        numTowersHeard: "Base Stations Heard Count",
        closestTower: "Closest Base Station",
        bestTowerUplink: "Best Base Station Uplink",
        bestTowerUplinkRange:"Best Base Station Uplink (Range)",
        bestTowerUplinkSprExport: "Best Base Station Uplink (For Export File)",
        tuningBestTowerUplink: "Tuning Best Base Station Uplink",
        tuningAvgSNR: "Tuning SNR",
        tuningAvgSS: "Tuning Signal Strength Average",
        bestTowerDownlink: "Best Base Station Downlink",
        bestTowerDownlinkRange: "Best Base Station Downlink (Range)",
        bestTowerDownlinkSprExport: "Best Base Station Downlink (For Export File)",
        timestamps: 'Timestamps',
        timeSync: "Last Time Sync",
        inTimeSync: "In Time Sync",
        notInTimeSync: "Not In Time Sync",
        timeSyncState: {
            IN_SYNC: "Yes",
            NOT_IN_SYNC: "No",
            NOT_APPLICABLE: "Not Applicable",
            UNKNOWN: "Unknown",
            null: "Unknown"
        },
        alarms: {
            powerFailAlarmActive: 'Power Fail Alarm Status',
            powerFailAlarmActiveItems: {
                active: "Active",
                restored: "Restored",
                neverFailed: "Never Failed"
            },
            powerFailAlarmStartDate: "Power Fail Start Date",
            powerRestoreAlarmStartDate: "Power Restore Date",
            lastPowerFailOrRestoreAlarmDate: "Last Power Or Restore Alarm",
            extendedPowerFailAlarm: "Power Fail Alarm Extended",
            extendedPowerRestore: "Power Fails (All) and Restorations Within",
            extendedPowerRestoreDate: "Power Fails (All) and Restorations Date Range",
            tamperAlarmActive: "Tamper Alarm Active",
        },
        extendedPowerFailAlarm: "Power Fail Alarm Extended",
        lastTowerReportDuration: 'Last Base Station Report Duration',
        transmitterEnabled: "Transmitter Enabled",
        lastTowerReport: "Last Base Station Report",
        lastUpdatedUplink: 'Last Uplink Stats Update',
        lastUpdatedDownlink: 'Last Downlink Stats Update',
        lastPerformanceEvent: 'Last Performance Event',
        lastPerformanceEventReason: 'Last Performance Event Reason',
        lastNoRouteCmdFailureActive: "Last No Route Failure",
        lastReadFailureCount: 'Last Read Failure Count',
        communicationState: 'Communication State',
        communicationStates: {
            ACTIVE: "Active",
            NEWLY_HEARD: "Newly Heard",
            NOT_HEARD: "Not Heard",
            POWER_FAILED: "Power Failed",
            REMOVED: "Removed",
            null: "Not Set"
        },
        active: 'Active',
        notActive: 'Not Active',
        address: "Address",
        factorySleep: "Factory Sleep",
        topLevelState: "Top Level State",
        topLevelStateNA2W: "NA2W Top Level State",
        topLevelStateHistory: "NA2W Top Level State History",
        topLevelStateNames: {
            Idle: "Idle",
            Walk_By_Drive_By: "Walk By - Drive By",
            Listen_After_Talk: "Listen After Talk",
            Middle_Of_Minute: "Middle Of Minute",
            Maintenance: "Maintenance",
            Active: "Active",
            null: "Not Set"
        },
        NCSCommandsSent: "NCS Commands Sent",
        ncsCommandTypesArqiva:{
            PING_SIMPLE_SETUP: "Ping Simple Setup",
            SETUP: "Send Setup Command",
            PING_FOR_TIME: "Ping for Time",
            PING_ORD_REPORT: "Ping ORD Report",
            PING_TOWER_SIGNAL_STRENGTH_REPORT: "Ping Base Station Signal Strength Report",
        },
        ncsCommandTypesNA: {
            PING_SIMPLE_SETUP: "Ping Simple Setup",
            SETUP: "Send Setup Command",
            PING_ADVANCED_SETUP: "Ping Advanced Setup",
            PING_ESM_CONFIG: "Ping ESM Config",
            PING_ESM_METADATA: "Ping ESM Meta Data",
        },
        commands: {
            commandType: "Command Type",
            priority: "Priority",
            attempts: "Attempts",
            status: "Status",
            user: "Initiated By",
            lastSent: "Last Sent",
            nextSend: "Next Send",
            cancel: "Cancel Command",
            globalDisable: "Disable Command Processing",
            globalEnable: "Enable Command Processing"
        },
        commandStatus: {
            CREATED: "Created",
            QUEUED: "Queued",
            IN_PROGRESS: "In Progress",
            EXPIRED: "Expired"
        },
        stats : {
            distanceToBestTower: "Distance To Best Base Station (miles)",
            distanceToBestTowerDownlink: "Distance From Best Base Station (miles)",
            rtsThroughput: "RTS Throughput %",
            lastRTS: "Last RTS",            
            l2ACKThroughput: "L2Ack Throughput %",
            l2ACKSuccess: "L2Ack Success %",
            lastL2ACK: "Last L2Ack",
            bulkThroughput: "Bulk Up Throughput %",
            lastBulk: "Last Bulk Up",
            highestDownlinkTowerAverageUseCount: "Time Sync Highest 7 Day Avg",
            highestDownlinkTowerAverageUseCountReportDate: "Time Sync Last Base Station Change",
            highestDownlinkTowerAverageUseCountReportDuration: "Time Sync Base Station Change Duration",
            pingSetupCmdFailureCount: "NCS Command Failures",
            mPassSetupCmdFailureCount: "mPass Setup Failures",
            lastNoRouteCmdFailure: "No Route Failure Range",
            lastDownlinkRouteCountTitle: "Downlink Route Count"
        },
        timeSyncDurations: {
            Day1: "1+ Days",
            Days7: "7+ Days",
            Days30Plus: "30+ Days"
        },
        transmitInterval: "Transmit Interval (STR)",
        transmitIntervalLat: "Transmit Interval (STR) LAT",
        transmitIntervalMom: "Transmit Interval (STR) MOM",
        receiveModesFNv1: {
            LISTEN_ALWAYS_BUDDY_MODE_ENABLED_FUTURE_LBT_BUDDY_MODE_ENABLED: "Buddy Enabled - Future",
            LISTEN_ALWAYS_BUDDY_MODE_ENABLED_FUTURE_LBT_BUDDY_MODE_DISABLED: "Buddy Disabled - Future",
            LISTEN_ALWAYS_BUDDY_MODE_ENABLED_10_KBPS: "10kbps Repeat Enabled",
            LISTEN_ALWAYS_BUDDY_MODE_DISABLED_10_KBPS: "10kbps Repeat Disabled",
            LISTEN_ALWAYS_BUDDY_MODE_ENABLED: "Buddy Enabled",
            LISTEN_ALWAYS_BUDDY_MODE_DISABLED: "Buddy Disabled",
            UNKNOWN: "Unknown",
            null: "Not Set"
        },
        receiveModesFNv2: {
            LISTEN_ALWAYS_BUDDY_MODE_ENABLED_FUTURE_LBT_BUDDY_MODE_ENABLED_10_KBPS: "10 kbps, Buddy Enabled - Future",
            LISTEN_ALWAYS_BUDDY_MODE_ENABLED_FUTURE_LBT_BUDDY_MODE_DISABLED_10_KBPS: "10 kbps, Buddy Disabled - Future",
            LISTEN_ALWAYS_BUDDY_MODE_ENABLED_10_KBPS: "10 kbps, Buddy Enabled",
            LISTEN_ALWAYS_BUDDY_MODE_DISABLED_10_KBPS: "10 kbps, Buddy Disabled",
            UNKNOWN: "Unknown",
            null: "Not Set"
        },
        receiveModesArqiva: {
            MPASS: "2GMSK 5K (mPass)",
            MPASS2: "2GMSK 10K (mPass2)",
            M4PASS: "4GMSK 10K (m4Pass)",
            M4PASS2: "4GMSK 20K (m4Pass2)"
        },
        transmissionModesArqiva: {
            SFSK2: "2SFSK",
            SFSK4: "4SFSK",
            SFSK8: "8SFSK",
            SFSK16: "16SFSK"
        },
        freqSupervisory: "Supervisory Frequencies",
        freqPriority: "Priority Frequencies",
        freqCnI: "C&I Frequencies",
        freqBoost: "Boost Frequencies",
        freqReceive: "Receive Frequencies",
        channel: "Channel",
        fec: 'FEC',
        bulkChannelUpDownErrMsg: "In most cases, you should not have your bulk up and down channels on the same frequency",
        adminChannel: "Admin Channel",
        currentBulkChannelPair: "Current Bulk Channel Pair",
        noCurrentBulkChannelPair: "Current Bulk Channel Pair Not Set",
        noTargetBulkChannelPair: "Target Bulk Channel Pair Not Set",
        previousBulkChannelPair: "Previous Bulk Channel Pair",
        noPreviousBulkChannelPair: "Previous Bulk Channel Pair Not Set",
        currentUplinkFreq: "Current Uplink Frequency",
        currentDownlinkFreq: "Current Downlink Frequency",
        previousUplinkFreq: "Previous Uplink Frequency",
        previousDownlinkFreq: "Previous Downlink Frequency",
        channelNames: {
            C_AND_I: "C&I Channel",
            PRIORITY: "Priority Channel",
            BOOST: "Boost Channel",
            RECEIVE: "Receive Channel",
            RECEIVE_B: "Receive B Channel",
            SUPERVISORY: "Supervisory Channel",
            BULK_DOWN: "Bulk Down Channel",
            BULK_DOWN_0: "Bulk Down 0 Channel",
            BULK_DOWN_1: "Bulk Down 1 Channel",
            BULK_DOWN_2: "Bulk Down 2 Channel",
            BULK_DOWN_3: "Bulk Down 3 Channel",
            BULK_DOWN_4: "Bulk Down 4 Channel",
            BULK_DOWN_5: "Bulk Down 5 Channel",
            BULK_DOWN_6: "Bulk Down 6 Channel",
            BULK_DOWN_7: "Bulk Down 7 Channel",
            BULK_DOWN_8: "Bulk Down 8 Channel",
            BULK_DOWN_9: "Bulk Down 9 Channel",
            BULK_DOWN_10: "Bulk Down 10 Channel",
            BULK_DOWN_11: "Bulk Down 11 Channel",
            BULK_DOWN_12: "Bulk Down 12 Channel",
            BULK_DOWN_13: "Bulk Down 13 Channel",
            BULK_DOWN_14: "Bulk Down 14 Channel",
            BULK_DOWN_CURRENT: "Bulk Down Channel",
            BULK_DOWN_PREVIOUS: "Bulk Down Previous Channel",
            BULK_UP: "Bulk Up Channel",
            BULK_UP_0: "Bulk Up 0 Channel",
            BULK_UP_1: "Bulk Up 1 Channel",
            BULK_UP_2: "Bulk Up 2 Channel",
            BULK_UP_3: "Bulk Up 3 Channel",
            BULK_UP_4: "Bulk Up 4 Channel",
            BULK_UP_5: "Bulk Up 5 Channel",
            BULK_UP_6: "Bulk Up 6 Channel",
            BULK_UP_7: "Bulk Up 7 Channel",
            BULK_UP_8: "Bulk Up 8 Channel",
            BULK_UP_9: "Bulk Up 9 Channel",
            BULK_UP_10: "Bulk Up 10 Channel",
            BULK_UP_11: "Bulk Up 11 Channel",
            BULK_UP_12: "Bulk Up 12 Channel",
            BULK_UP_13: "Bulk Up 13 Channel",
            BULK_UP_14: "Bulk Up 14 Channel",
            BULK_UP_CURRENT: "Bulk Up Channel",
            BULK_UP_PREVIOUS: "Bulk Up Previous Channel",
            L2ACK_1: "L2ACK 1 Channel",
            L2ACK_2: "L2ACK 2 Channel",
            L2ACK_3: "L2ACK 3 Channel",
            RTS: "RTS Channel"
        },
        radioDetailChannelNames: {
            C_AND_I: "C&I",
            PRIORITY: "Priority",
            BOOST: "Boost",
            RECEIVE: "Receive",
            RECEIVE_B: "Receive B",
            SUPERVISORY: "Supervisory",
            BULK_DOWN: "Bulk Down",
            BULK0: "Bulk Pair 0",
            BULK1: "Bulk Pair 1",
            BULK2: "Bulk Pair 2",
            BULK3: "Bulk Pair 3",
            BULK4: "Bulk Pair 4",
            BULK5: "Bulk Pair 5",
            BULK6: "Bulk Pair 6",
            BULK7: "Bulk Pair 7",
            BULK8: "Bulk Pair 8",
            BULK9: "Bulk Pair 9",
            BULK10: "Bulk Pair 10",
            BULK11: "Bulk Pair 11",
            BULK12: "Bulk Pair 12",
            BULK13: "Bulk Pair 13",
            BULK14: "Bulk Pair 14",
            BULK_DOWN_0: "Bulk Down 0",
            BULK_DOWN_1: "Bulk Down 1",
            BULK_DOWN_2: "Bulk Down 2",
            BULK_DOWN_3: "Bulk Down 3",
            BULK_DOWN_4: "Bulk Down 4",
            BULK_DOWN_5: "Bulk Down 5",
            BULK_DOWN_6: "Bulk Down 6",
            BULK_DOWN_7: "Bulk Down 7",
            BULK_DOWN_8: "Bulk Down 8",
            BULK_DOWN_9: "Bulk Down 9",
            BULK_DOWN_10: "Bulk Down 10",
            BULK_DOWN_11: "Bulk Down 11",
            BULK_DOWN_12: "Bulk Down 12",
            BULK_DOWN_13: "Bulk Down 13",
            BULK_DOWN_14: "Bulk Down 14",
            BULK_DOWN_CURRENT: "Bulk Down Current",
            BULK_DOWN_PREVIOUS: "Bulk Down Previous",
            BULK_UP: "Bulk",
            BULK_UP_0: "Bulk Up 0",
            BULK_UP_1: "Bulk Up 1",
            BULK_UP_2: "Bulk Up 2",
            BULK_UP_3: "Bulk Up 3",
            BULK_UP_4: "Bulk Up 4",
            BULK_UP_5: "Bulk Up 5",
            BULK_UP_6: "Bulk Up 6",
            BULK_UP_7: "Bulk Up 7",
            BULK_UP_8: "Bulk Up 8",
            BULK_UP_9: "Bulk Up 9",
            BULK_UP_10: "Bulk Up 10",
            BULK_UP_11: "Bulk Up 11",
            BULK_UP_12: "Bulk Up 12",
            BULK_UP_13: "Bulk Up 13",
            BULK_UP_14: "Bulk Up 14",
            BULK_UP_CURRENT: "Bulk Up Current",
            BULK_UP_PREVIOUS: "Bulk Up Previous",
            BULKCURRENT: "Bulk Current Pair",
            BULKPREVIOUS: "Bulk Previous Pair",
            L2ACK_1: "L2ACK 1",
            L2ACK_2: "L2ACK 2",
            L2ACK_3: "L2ACK 3",
            RTS: "RTS"
        },
        channelNamesExpected: {
            C_AND_I: "Expected C&I Channel",
            PRIORITY: "Expected Priority Channel",
            BOOST: "Expected Boost Channel",
            RECEIVE: "Expected Receive Channel",
            RECEIVE_B: "Expected Receive B Channel",
            SUPERVISORY: "Expected Supervisory Channel",
            L2ACK_1: "Expected L2ACK 1",
            L2ACK_2: "Expected L2ACK 2",
            L2ACK_3: "Expected L2ACK 3",
            RTS: "Expected RTS",
            bulkUplinkFreq: "Expected Bulk Uplink Frequency",
            bulkDownlinkFreq: "Expected Bulk Downlink Frequency",
        },
        bulkPair: "Bulk Pair",
        currentBulkPair: 'Current Bulk Pair',
        changingBulkPair: 'Changing To Bulk Pair {index}',
        changingFrequency: 'Changing Frequency To {name}',
        changingModulation: 'Changing Modulation To {name}',
        disableFlexnetTransmitter: 'Disable Transmitter',
        enableFlexnetTransmitter: 'Enable Transmitter',
        disabledFlexnetTransmitter: 'Transmitter Disable In Progress',
        enabledFlexnetTransmitter: 'Transmitter Enable In Progress',
        previousBulkPair: 'Previous Bulk Pair',
        targetBulkPair: 'Target Bulk Pair',
        radiosByModulation: "ESM Radios per Modulation and FEC",
        sanpshots: "snapshots",
        frequency: "Frequency (MHz)",
        supervisoryModulation: "Supervisory Modulation",
        supervisoryFEC: "Supervisory FEC",
        supervisoryTarget: "Supervisory Target",
        supervisoryModulationTarget: "Supervisory Modulation Target",
        receiveModulation: "Receive Modulation",
        receiveTarget: "Receive Target",
        receiveModulationTarget: "Receive Modulation Target",
        priorityModulation: "Priority Modulation",
        priorityTarget: "Priority Target",
        priorityModulationTarget: "Priority Modulation Target",
        candiModulation: "C & I Modulation",
        candiTarget: "C & I Target",
        candiModulationTarget: "C & I Modulation Target",
        boostModulation: "Boost Modulation",
        boostTarget: "Boost Target",
        boostModulationTarget: "Boost Modulation Target",
        rtsModulation: "RTS Modulation",
        rtsTarget: "RTS Target",
        rtsModulationTarget: "RTS Modulation Target",
        bulkUpModulation: "Bulk Up Modulation",
        bulkUpTarget: "Bulk Up Target",
        bulkUpModulationTarget: "Bulk Up Target Modulation",
        bulkDownModulation: "Bulk Down Modulation",
        bulkDownTarget: "Bulk Down Target",
        bulkDownModulationTarget: "Bulk Down Target Modulation",
        l2Ack1Target: "L2ACK 1 Target",
        l2Ack1Modulation: "L2ACK 1 Modulation",
        l2Ack1ModulationTarget: "L2ACK 1 Modulation Target",
        l2Ack2Target: "L2ACK 2 Target",
        l2Ack2Modulation: "L2ACK 2 Modulation",
        l2Ack2ModulationTarget: "L2ACK 2 Modulation Target",
        l2Ack3Target: "L2ACK 3 Target",
        l2Ack3Modulation: "L2ACK 3 Modulation",
        l2Ack3ModulationTarget: "L2ACK 3 Modulation Target",
        esmReads: "ESM Reads Yesterday",
        esmSnapshots: "ESM Snapshots per Read",
        modulation: "Modulation",
        modulations: {
            FSK_DISABLED: 'Disabled',
            FSK7: '7FSK',
            FSK13: '13FSK 1/2 FEC',
            FSK13_R34: '13FSK 3/4 FEC',
            FSK_CNI: 'C&I - 7FSK Half-Baud',
            FSK_PRI: 'Priority - 13FSK Half-Baud',
            FSK_BOOST: 'Boost',
            FSK13_BOTH: 'FSK13 BOTH',
            SFSK2: '2SFSK',
            SFSK4: '4SFSK',
            SFSK8: '8SFSK',
            SFSK16: '16SFSK',
            SFSK2_HB: '2SFSK Half-Baud',
            SFSK4_HB: '4SFSK Half-Baud',
            SFSK8_HB: '8SFSK Half-Baud',
            SFSK16_HB: '16SFSK Half-Baud',
            MPASS: 'mPass - 5 kbps',
            MPASS2: 'mPass2 - 10 kbps',
            M4PASS: 'm4Pass - 10 kbps',
            M4PASS2: 'm4Pass2 - 20 kbps',
            MPASS12K: 'mPass 12K',
            RADIO_SFSK2: "Radio 2SFSK",
            RADIO_SFSK4: "Radio 4SFSK",
            SFSK_BOOST: "SFSK Boost",
            FSK13_REDUCED: "FSK13 Reduced",
            FSK13_EXTENDED: "FSK13 Extended",
            UNKNOWN: 'Unknown',
            null: 'Not Set'
        },
        fullMPassMode: 'Full mPass Mode',
        ordFullMpass: 'ORD (Full mPass Mode)',
        lowPowerEnabled: "Low Power Mode Enabled",
        lowPowerMode: "Low Power Mode",
        mptPercentage: "MPT %",
        lastUpdated: 'Last Updated Daily Stats',
        endpointSnr: "Endpoint SNR",
        endpointNoise: "Endpoint Noise",
        tuningNoise: "Tuning Noise",
        tuningSignalStrength: "Tuning Signal Strength",
        uplinkEndpointSnr: "Uplink Endpoint SNR",
        downlinkEndpointSnr: "Downlink Endpoint SNR",
        use24Ct: "24 Hour Usage Count",
        use24Ct2: "Usage Count (24 Hour)",
        timeSyncCount: "Time Sync Count Moving Avg",
        useCount: "Usage Count Daily Avg",
        useCount7Days: "Usage Count",
        useCount7DaysTooltip: "Number of times this route was used over the last 7 days from the given date",
        uplinkUseCount: "Uplink Usage Count",
        uplinkSamplesCount: "Uplink Samples Count",
        uplinkSamplesCountTooltip: "Uplink Samples received for the day",
        uplnkUseCount: "Uplink Usage Count Daily Avg",
        dwnlnkUseCount: 'Downlink Usage Count Daily Avg',
        avgSignalStrength: "Signal Strength Daily Avg",
        uplnkAvgSignalStrength: "Uplink Signal Strength Daily Avg",
        dwnlnkAvgSignalStrength: "Downlink Signal Strength Daily Avg",
        daysRouteUsed: "Days Route Used",
        daysRouteUsedTooltip: "Days this route was used over the given time range",
        daysRouteUsedTooltipArqiva: "Days this route was used over the last 30 days",
        lastUsed: "Last Used",
        uplnkLastUsed: "Uplink Last Used",
        dwnlnkLastUsed: "Downlink Last Used",
        routes: "Uplink Routes Used {routeDurationDays}",
        buddyRepeat: "Buddy Repeat",
        uplinkFrequency: "Uplink Supervisory Frequency",
        destId: "Destination ID",
        destType: "Destination Type",
        routeCount: "Daily Uplink Route Count",
        routeCountTitle: 'Uplink Route Count',
        routeCountsPerTime: "Uplink Route Counts",
        SNR: 'SNR {dayUsed}',
        avgSNRTooltip: 'Average Daily SNR for selected time frame',
        uplnkAvgSNRTooltip: 'Average Uplink SNR for day',
        dwnlnkAvgSNRTooltip: 'Average Downlink Daily SNR for selected time frame',
        avgSSTooltip: 'Average Daily Signal Strength for selected time frame',
        uplnkAvgSSTooltip: 'Average Uplink Signal Strength for the day',
        dwnlnkAvgSSTooltip: 'Average Downlink Daily Signal Strength for selected time frame',
        endpointNoiseTooltip: "Average Endpoint Noise for the day",
        useCountTooltip: 'Average Daily Usage Count for selected time frame',
        uplnkUseCountTooltip: 'Average Uplink Daily Usage Count for selected time frame',
        dwnlnkUseCountTooltip: 'The daily moving average of the number of base station time syncs heard over the last 7 days',
        avgSNRGraphTitle: 'Average SNR for Last {days} Days',
        avgSSGraphTitle: 'Average Signal Strength for Last {days} Days',
        useCountGraphTitle: 'Usage Count for Last {days} Days',
        lowestSNR: 'Lowest SNR',
        oneRoute: 'One Uplink Route',
        multipleRoutes: 'Multiple Uplink Routes',
        snrThresholdTitle: 'Maximum SNR',
        detailsTargetTT: 'Changing to {targetValue}',
        arqivaTitles: {
            uplinkRouteCount: "Uplink Route Count",
            uplinkRouteCountsPerTime: "Uplink Route Counts Average Since {dateString}",
            downlinkRouteCount: "Downlink Route Count",
            downlinkRouteCountsPerTime: "Downlink Route Counts Average Since {dateString}",
            snrDirections: "SNR Avg (Uplink / Downlink)",
            bestTowerDirections: "Best Base Station (Uplink / Downlink)",
            towersHeard: "Base Stations Heard",
            uplinkRoutes: {
                lastORDReportTime: "Last ORD Report"
            },
            lastORDReportDuration: "ORD Report Duration",
            lifeCycleStates: {
                INSTALL: 'Installed',
                INVENTORY: 'Inventory',
                NOT_ASSIGNED: 'Not Assigned',
                UNKNOWN: 'Unknown',
                REMOVED: 'Removed',
                null: 'Not Set'
            }
        },
        location: {
            location: 'Location',
            gps: {
                latitude: "Latitude",
                longitude: "Longitude",
                latLongStatusTitle: 'Location Status',
                latLongStatus: "Location Status"
            },
            streetAddress: {
                zipCode: "Postal Code"
            }
        },
        channels: {
            channels: 'Channels',
            BOOST: {
                frequencyTitle: "Boost Frequencies"
            },
            C_AND_I: {
                frequencyTitle: "C&I Frequencies"
            },
            PRIORITY: {
                frequencyTitle: "Priority Frequencies"
            },
            RECEIVE: {
                frequencyTitle: "Receive Frequencies"
            },
            SUPERVISORY: {
                frequencyTitle: "Supervisory Frequencies"
            }
        },
        uplinkRoutes: {
            repeatedMessagesCount: "Repeated Messages",
            lastORDReportTime: "Last ORD Report"
        },
        lastORDReportDuration: "Last ORD Report Duration",
        receiveOperationalModeTitle: "Receiver Operational Mode",
        topLevelStateTitle: "Top Level State",
        deviceTypeTitle: "Device Type",
        multipleStatsTitle: "ESM Radios per Modulation and FEC",
        utilityTypeTitle: "Utility Type",
        effectiveTransmitOperationalModeTitle: "Transmitter Operational Mode",
        effectiveSupervisoryTransmitIntervalTitle: "Transmit Interval (STR)",
        radioStales: "RF Stales",
        radiosUplinkRouteCount: "Radio Counts Per Uplink Route Count Category",
        radiosDownlinkRouteCount: "Radio Counts Per Downlink Route Count Category",
        fnFirmwareVersion: "FlexNet Firmware Version",
        firmwareVersion: "Firmware Version",
        hostFirmwareVersion: "Host Firmware Version",
        sdkFirmwareVersion: 'SDK Firmware Version',
        fwdlDates: 'Firmware Download Date',
        ncoHistoryId: 'Last Tuning Update NCO',
        routeCountRange: {
            ZERO: "0",
            ONE: "1",
            TWO_TO_SIX: "2-6",
            TWO_TO_TEN: "2-10",
            SEVEN_OR_MORE: "7+",
            ELEVEN_OR_MORE: "11+"
        },
        destTypes: {
            0: 'Base Station',
            1: 'Buddy',
            2: 'FNv2 Buddy'
        },
        avgSnrTrend: 'Avg SNR 7 Day Trend',
        avgSignalStrengthTrend: 'Avg Sig Strength 7 Day Trend',
        useCountTrend: 'Usage Count 7 Day Trend',
        errors: {
            retrieveDetails: 'Error retrieving radios details for rep id {id}',
            retrieveFrequencies: 'Error retreiving filter frequencies',
            retrieveRoutes: 'Error retrieving Routes',
            retrieveOrdRoutes: 'Error retrieving ORD Routes',
            retrieveBuddyRoutes: 'Error retrieving Buddy Routes',
            retrieveTower: 'Error retrieving towers for radio'
        },
        snr: 'Uplink Signal to Noise Ratio',
        snrGraphLabel: 'dB',
        signalStrengthPerRoute: "Uplink Signal Strength Per Route",
        useCountPerRoute: "Use Count Per Uplink Route",
        MsgToBuddy: 'Messages Received from Out of Reach Devices',
        MsgToBuddyGraphLabel: 'Count',
        MsgFromORD: 'Messages Sent to Buddy',
        MsgFromORDGraphLabel: 'Count',
        radioConfig: 'Radio Configuration',
        radioTuning: 'Radio Tuning',
        configuration: "Configuration",
        showRadiosTT: 'View Radios',
        db: {
            seriesFrequency: "Freq",
            seriesBuddy: "(Buddy)",
            graphError: 'Error retrieving graph data for {graphName}',
            dest: 'Dest',
            destination: 'Destination',
            snrTitle: 'Uplink Signal to Noise Ratio',
            signalStrengthTitle: 'Uplink Signal Strength',
            signalStrengthGraphLabel: 'dB',
            msgsSentToBuddyTitle: 'Messages Sent to Buddy',
            msgsSentToBuddyTT: 'Messages sent to a buddy from this radio',
            msgsFromOrdTT: 'Messages this radio received as a buddy from out of reach devices',
            snrTT: 'Average Uplink Signal to Noise ratio for this radio.',
            ssTitle: 'Signal Strength per Uplink Route',
            ssTT: 'Average Signal Strength per Uplink Route for this radio.',
            useCountTitle: 'Use Count per Uplink Route',
            useCountTT: 'Average Use Count per Uplink Route for this radio.',
            lifeCycleStateTitle: 'Life Cycle State',
            staleHistoryTitle: 'Historical Stale Counts',
            topLevelStateTSTitle: 'Top Level State Counts'
        },
        stales: "RF Stales",
        staleFilters: {
            Day1: "1 Day",
            Days2: "2 Days",
            Days3: "3 Days",
            Days4Plus: "4+ Days"
        },
        powerFailure: {
            onePlusHr: "1+ Hour",
            fourPlusHr: "4+ Hour",
            eightPlusHr: "8+ Hour",
            twelvePlusHr: "12+ Hour"
        },
        powerRestore: {
            "Min30Less": "Last 30 Minutes",
            "Hour1Less": "Last Hour",
            "Hour12Less": "Last 12 Hours",
            "Days1Less": "Last Day",
            "Days3Less": "Last 3 Days",
        },
        StaleRadios: {
            "1Day": "1 Day",
            "2Day": "2 Days",
            "3Day": "3 Days",
            "4PlusDays": "4+ Days"
        },
        utilityType: "Utility Type",
        lifecycleStateTimeline: 'Life Cycle State Over Time',
        lifecycleState: "Life Cycle State",
        lifecycleStates: {
            INSTALL: 'Installed',
            INVENTORY: 'Inventory',
            NOT_ASSIGNED: 'Not Assigned',
            RETIRED: 'Retired',
            RMA: 'RMA',
            REMOVED: 'Removed',
            SWAP: 'Swap',
            UNKNOWN: 'Unknown',
            null: 'Not Set'
        },
        flexnetVersion: "FlexNet Version",
        flexnetVersions: {
            NA:{
                null: "Not Set",
                FNV1: "FNV1",
                FNV2: "FNV2",
            },
            arqiva: {
                null: "Not Set",
                CommsHub: "CommsHub"
            }
        },
        encryptionState: "Encryption",
        effectiveTransmitOperationalMode: "Transmitter Operational Mode",
        effectiveSupervisoryTransmitInterval: "Transmit Interval (STR)",
        receiveOperationalMode: "Receiver Operational Mode",
        needSetup: "Needs Setup",
        tableFilterTuningOptions: {
            SYSTEM_TUNED: "Auto updates by NCS",
            MANUAL_TUNED: "Manual updates by User",
            SYSTEM_SUGGEST: "NCS suggests updates but takes no action"
        },
        tuningOptions: {
            SYSTEM_TUNED: "Auto updates by NCS",
            SYSTEM_SUGGEST: "NCS suggests updates but takes no action"
        },
        tuning: {
            capabilityState: 'Tuning Capability State',
            capabilityStates: {
                CONFIGURABLE: 'Configurable',
                READ_PINGS: 'Read Pings',
                NONE: 'None',
                UNKNOWN: 'Unknown',
                null: 'Not Set'
            },
            lastAnalysisDate: "Last Tuning Uplink Route Analysis",
            changeLastAnalysisDate: "Change Last Tuning Uplink Route Analysis Days Setting",
            ruleCurrentMatches: "Radios per Current Tuning Rule",
            ruleTargetMatches: "Radio Configuration Queue History",
            ruleAllocation: "Radio Configuration Queue",
            frequencyConfig: "Tuning Frequency Targets",
            modulationConfig: "Tuning Modulation Targets",
            notPlanned: "Not Planned",
            tuningOption: "Subsequent Tuning Actions",
            currentGroup: "Current Tuning Group",
            targetGroup: "Target Tuning Group",
            otherGroups: "Special Condition Groups",
            reason: "Tuning Reason",
            needSetupReason: "Needs Setup Reason",
            inProgress: "Tuning In Progress",
            isTempORD: "Temporary ORD State",
            isORD: 'ORD',
            isTunableDeviceType: "Tunable Device Type",
            setupCommandInProgress: 'Tuning In Progress',
            isCompulsoryRepeater: "Compulsory Repeater",
            lastTuningDate: "Last System Tuning Attempt",
            lastTuningChainUpdate: "Last Tuning Chain Update",
            lastNCOAnalysis: "Last Periodic NCO Analysis",
            lastNCOGroupAssignmentTime: "Last NCO Group Assignment",
            lastPeriodicChannelBalanceAnalysis: "Last Periodic Channel Balance Analysis",
            membershipGroup: "Target Group",
            membershipGroupIsTuning: "Target Group is Tuning",
            actionGroup: "Tuning Configured",
            actionEnabled: "Action Enabled",
            actionDisabled: "Action Disabled",
            isSuspectedORD: "Suspected ORD",
            defaultRuleMembershipString: "Radios not matching any other rule",
            rapidTune: {
                rapidTuneAvgTimeOnChannel: 'Rapid Tune Avg Time On Channel',
                rapidTuneEndpointsTuned: 'Rapid Tune Endpoints Tuned',
                rapidTuneEndpointsPerChannel: 'Rapid Tune Endpoints Per Channel',
                rapidTuneTimeToTune: 'Rapid Tune Time to Tune',
                rapidTuneSweepTime: 'Rapid Tune Sweep Time',
                rapidTuneTimeToTuneAve: 'Rapid Tune Average Time to Tune',
                rapidTuneSweepTimeAve: 'Rapid Tune Average Sweep Time',
                rapidTuneRadiosCount: 'Radios Rapid Tuned',
                channelAvg: {
                    timeOnInstallChannel: 'Time on Install Channel',
                    timeOnAdminChannel: 'Time on Admin Channel',
                    timeToRapidTuneCompletion: 'Time to Rapid Tune Completion',
                }
            },
            uplinkSamples: 'Uplink Samples Received',
            downlinkSamples: 'Downlink Samples Received',
            exitTime: 'Rapid Tune Exit Time',
            stdDev: 'Best Tower Standard Deviation',
            rapidTuneChannels: {
                ADMIN: 'Admin Channel',
                BULK: 'Bulk Channel',
                INSTALL: 'Install Channel',
                COMPLETION: 'Completed'
            },
            rapidTuneStatus: {
                ALREADY_KNOWN: 'Already Known to RNI',
                BULK_CHANNELS_UNAVAILABLE:"Bulk Channel Unavailable",
                BUDDY_ROUTE_DETECTED: 'Buddy Route Detected',
                BULK_TARGETS_SELECTED: 'Bulk Target Channel Selected',
                //CHANNELS_UNAVAILABLE: 'Channels Unavailable',
                COLLECTING_DATA: 'Collecting Data',
                INSTALL: 'Moved to Install Channel',
                INSTALL_TARGETS_SELECTED: 'Install Targets Selected',
                INSTALL_CHANNELS_UNAVAILABLE: 'Install Channels Unavailable',
                NO_TUNING_CHANGES: "Channel Balancing produced no changes",
                PENDING_READ_ONLY: 'Pending Read Only',
                TUNING_COMPLETED: 'Tuning Completed',
                TUNING_EXPIRED: 'Tuning Expired',
                WAITING_INSTALL_TIME_THRESHOLD: 'Waiting for Install Time Threshold',
                WAITING_RNI_IMPORT: 'Waiting for RNI Import',
                WAITING_STATIC_SETUP: 'Waiting for Static Setup'
            },
            rapidTuneTargets: {
                channels: 'Channels',
                currentChannelPair: 'Current Channel Pair',
                targetChannelPair: "Target Channel Pair",
                fullMPassMode: 'Full MPass Mode',
                lowPowerEnabled: 'Low Power Enabled',
                mPassBuddyRepeatEnabled: 'MPass Buddy Repeat Enabled',
                staticRebroadcaster: 'Static Rebroadcaster',
                tuningOption: 'Tuning Option',
                minPriority: 'Min Priority'
            },
            lastReadFailureCount: 'Last Read Failure Count',
            maxReadGapMins: 'Max Read Gap',
            maxReadGapMinsFilter: 'Max Read Gap (Minutes)',
            readChanceOfFailure: 'Read Chance of Failure %',
            readNormalThroughput: 'Normal Read Throughput',
            readRepeatedThroughput: 'Buddied Read Throughput',
            readBoostedThroughput: 'Boosted Read Throughput',
            historyDepthMins: 'Average Read History Depth',
            minReadHistoryMinutes: 'Min Read History',
            recentPerformanceEvent: 'Recent Performance Event',
            couldNotComputeReadGaps: 'Could Not Compute Read Gaps',
            couldNotComputeThroughputs: 'Could Not Compute Throughputs',
            readTypes: {
                REPEATED: 'Buddied',
                NORMAL: 'Normal',
                POLLED: 'Polled',
                BOOSTED: 'Boosted'
            },
            //TODO fix radio reads code!!!
            lastReadHadFailure: 'Last Read Had Failure',
            lastReadFailureDate: 'Last Read Failure Date',
            appDataSize: 'App Data Size (Bytes)',
            lastReadMsgBoosted: 'Last Boosted Read',
            lastReadMsgNormal: 'Last Normal Read',
            lastReadMsgPolled: 'Last Polled Read',
            lastReadMsgRepeated: 'Last Buddied Read',
            notMoving: "Not Moving",
            movingIn: "Moving In",
            movingOut: "Moving Out",
            tuningResultFlags: 'Tuning Result Flags',
            tuningResultFlagValue: {
                CHANNEL_BALANCE_RESET_CHANNEL: 'Channel Balancing - Reset Channel'
            }
        },
        isTuningTooltip: "<b>NetTune will:</b><ul>" +
            "<li>Change this endpoint's transmission and receive modulations to the selected values</li>" +
            "<li>Change this endpoint to a different channel based on load vs capacity</li></ul>" +
            "<b>NetTune may:</b><ul>" +
            "<li>Use this endpoint as a buddy to support out-of-reach devices</li>" +
            "<li>Use this endpoint as a static rebroadcaster to support out-of-reach-devices</li></ul>",
        tuneCommsHubFromFile: 'Tune Comms Hub From File',
        tuneRadiosFromFile: 'Tune Radios From File',
        invalidSetupConfigFile: 'Invalid column, make sure all columns are valid',
        tuneCommsHubInvalidFileSize: 'Uploaded Invalid File, a maximum of 100 comms hubs can be tuned at a time',
        tuneCommsHubUploadSuccess: 'File uploaded',
        tuneCommsHubFromFileErr: 'Invalid file',
        noRuleDiff: "No differences detected, will not save",
        addRadioToSet: 'Add Radio To Set',
        removeRadioFromSet: 'Remove Radio From Set',
        addRadioToSetTitle: 'Add Radio To Set',
        removeRadioFromSetTitle: 'Remove Radio from Set',
        singleRadioPingSentMsg: 'Ping command sent to radio',
        singleRadioPingSentErrorMsg: 'Error sending Ping {pingType} command to radio, see log',
        singleRadioSetupSentErrorMsg: "Error sending Setup command to radio, see log",
        singleRadioTuningRequestMade: "Tuning the radio",
        singleRadioTuningErrorMsg: "Error in Tuning Radio, see log",
        detailActionsSubTitle: 'Radio Actions',
        commandCanceled: "Command {type} canceled for radio {radio}",
        commandCanceledErrorMsg: "Failed to cancel command {type} for {radio}, Only commands in Queued state can be canceled",
        setGlobalCommandSettingErrorMsg: "Error changing global command processing setting, see log",
        sync :{
            RNI_Radios: "Synchronize Radios from RNI",
            successSyncRadioRNI : "Successfully initiated radio synchronization from RNI",
            syncRadiosRNIError: "Sync Failed, see log",
        },
        dailyDurations: {
            Day1: "1 Day",
            Days1Plus: "1+ Days",
            Days1Less: "1 Day Ago or Less",
            Days2: "2 Days",
            Days2Less: "2 Days Ago or Less",
            Days3: "3 Days",
            Days4Plus: "4+ Days",
            Days4Less: "4 Days Ago or Less",
            Days4PlusAndNull: "4+ Days or Never Heard",
            Days7Plus: "7+ Days",
            Days7PlusAndNull: "7+ Days or Never Heard",
            Days7Less: "7 Days Ago or Less",
            Days8Plus: "8+ Days",
            Days8PlusAndNull: "8+ Days or Never Heard",
            Days30Plus: "30+ Days",
            Days30Less: "30 Days Ago or Less"
        },
        navToGroup: "Navigate to group definition for ",
        device: {
            esm: 'ESM',
            meterSampleRateTitle: "Sample Rate (MSR)"
        },
        transmitsPerMAL: 'Transmits per MAL Period',
        transmitIntervalWhitelist: 'Transmit Interval Whitelist',
        modulationsNA: {
            FNV1: {
                FSK_DISABLED: 'Disabled',
                FSK7: '7FSK',
                FSK13: '13FSK',
                FSK13_R34: '13FSK R34',
                FSK_CNI: 'C&I - 7FSK Half-Baud',
                FSK_PRI: 'Priority - 13FSK Half-Baud',
                FSK_BOOST: 'Boost',
                FSK13_BOTH: 'FSK13 BOTH',
                SFSK2: '2SFSK',
                SFSK4: '4SFSK',
                SFSK8: '8SFSK',
                SFSK16: '16SFSK',
                SFSK2_HB: '2SFSK Half-Baud',
                SFSK4_HB: '4SFSK Half-Baud',
                SFSK8_HB: '8SFSK Half-Baud',
                SFSK16_HB: '16SFSK Half-Baud',
                MPASS: 'mPass - 5 kbps',
                MPASS2: 'mPass2 - 10 kbps',
                M4PASS: 'm4Pass - 10 kbps',
                M4PASS2: 'm4Pass2 - 20 kbps',
                MPASS12K: 'mPass 12K',
                RADIO_SFSK2: "Radio 2SFSK",
                RADIO_SFSK4: "Radio 4SFSK",
                SFSK_BOOST: "SFSK Boost",
                FSK13_REDUCED: "FSK13 Reduced",
                FSK13_EXTENDED: "FSK13 Extended",
                UNKNOWN: 'Unknown',
            },
            FNV2: {
                FSK_DISABLED: 'Disabled',
                FSK7: '7FSK',
                FSK13: '13FSK',
                FSK13_R34: '13FSK R34',
                FSK_CNI: 'C&I - 7FSK Half-Baud',
                FSK_PRI: 'Priority - 13FSK Half-Baud',
                FSK_BOOST: 'Boost',
                FSK13_BOTH: 'FSK13 BOTH',
                SFSK2: '2SFSK',
                SFSK4: '4SFSK',
                SFSK8: '8SFSK',
                SFSK16: '16SFSK',
                SFSK2_HB: '2SFSK Half-Baud',
                SFSK4_HB: '4SFSK Half-Baud',
                SFSK8_HB: '8SFSK Half-Baud',
                SFSK16_HB: '16SFSK Half-Baud',
                MPASS: 'mPass - 5 kbps',
                MPASS2: 'mPass2 - 10 kbps',
                M4PASS: 'm4Pass - 10 kbps',
                M4PASS2: 'm4Pass2 - 20 kbps',
                MPASS12K: 'mPass 12K',
                RADIO_SFSK2: "Radio 2SFSK",
                RADIO_SFSK4: "Radio 4SFSK",
                SFSK_BOOST: "SFSK Boost",
                FSK13_REDUCED: "13FSK Reduced",
                FSK13_EXTENDED: "13FSK xtended",
                UNKNOWN: 'Unknown',   
            }
        },
        fecNA: {
            FNV1: {
                THREE_QUARTER_K7: '3/4 Rate, K=7',
                THREE_QUARTER_K4: '3/4 Rate, K=4',
                HALF: '1/2 Rate, K=3',
                NONE: 'None',
            },
            FNV2: {
                THREE_QUARTER_K7: '3/4 Rate, K=7',
                THREE_QUARTER_K4: '3/4 Rate, K=4',
                HALF: '1/2 Rate, K=3',
                NONE: 'None',
            }
        },
        transmitModesNA: {
            NORMAL: "Normal",
            MESSAGE_PASS: "MPass",
            BOOST_MODE: "Boost Mode",
            NORMAL_HALF_BAUD_RATE: "Half Baud Rate",
            MPASS_NORMAL_MIX_1_1: "MPass 1:1",
            MPASS_NORMAL_MIX_1_2: "MPass 1:2",
            MPASS_NORMAL_MIX_1_3: "MPass 1:3",
            MPASS_NORMAL_MIX_1_4: "MPass 1:4",
            MPASS_NORMAL_MIX_1_5: "MPass 1:5",
            MPASS_NORMAL_MIX_1_8: "MPass 1:8",
            MPASS_NORMAL_MIX_1_16: "MPass 1:16",
            BOOST_NORMAL_MIX_1_1: "Boost Mode 1:1",
            BOOST_NORMAL_MIX_1_2: "Boost Mode 1:2",
            BOOST_NORMAL_MIX_1_3: "Boost Mode 1:3",
            BOOST_NORMAL_MIX_1_4: "Boost Mode 1:4",
            BOOST_NORMAL_MIX_1_5: "Boost Mode 1:5",
            BOOST_NORMAL_MIX_1_8: "Boost Mode 1:8",
            TRI_MODE_1_1_13: "Tri Mode 1:1:3",
            UNKNOWN: "Unknown",
            null: "Not Set"
        },
        transmitModesArqiva: {
            NORMAL: "Normal",
            MESSAGE_PASS: "MPass",
            UNKNOWN: "Unknown",
            null: "Not Set"            
        },
        clearRequiredFiltersDialogNA: "The following filters are required for tuning rules. <br/>" + 
        "They will be moved from the addt'l membership list to the required membership list.<br/><br/>" + 
        "Flexnet Version, ESM, Max Read Gap<br/><br/>" + 
        "Are you sure you want to continue?",
        clearRequiredFiltersDialogArqiva: "The following filters are required for tuning rules. <br/>" + 
        "They will be moved from the addt'l membership list to the required membership list.<br/><br/>" + 
        "Downlink Endpoint SNR<br/><br/>" + 
        "Are you sure you want to continue?",
        UPLINK: "Uplink",
        DOWNLINK: "Downlink",
        ALL: "All",
        POLL_RESPONSE: "Poll Response",
        reads: 'Reads',
        sampleCount: 'Sample Count',
        failCount: 'Fail Count',
        toi: 'Time of Intercept',
        readTime: 'Read Time',
        tuningOptionsHeader: 'Tuning Targets',
        requiredCriteria: 'Required Membership',
        communicationMode: 'Communication Mode',
        communicationModes: {
            null: '',
            'UNKNOWN': 'Unknown',
            'AMI': 'AMI Mode',
            'OPT_OUT': 'Opt-Out Mode',
            'ON_DEMAND': 'On-Demand Mode'
        },
        lastReadHadFailure: 'Last Read Had Failure',
        lastReadFailureDate: 'Last Read Failure Date',
        appDataSize: 'App Data Size (Bytes)',
        currentConfigWhitelisted: "Current Config Whitelisted",
        modFecCombination: "Modulation & FEC",
        comparisonFilter: 'Comparison Filter',
        comparisonFilterMembershipCriteria: '',
        shorthand: {
            flexnetVersion: "FNV",
            bestAverageSNR: "SNR",
            tuning: {
                maxReadGapMins: 'Max Read Gap',
                readChanceOfFailure: 'Read COF',
                minReadHistoryMinutes: 'Min Read History',
            },
            device: {
                esm: 'ESM'
            },
            tuneMatchingRadios: "Tune",
            stats: {
                bestTowerAverageSNRDownlink: 'Downlink SNR'
            },
            tuningBestUplinkTower: {
                averageSNR: 'Tuning SNR'
            },
            modulation: 'Mod',
            fullMPassMode: 'mPass'
        },
        tempHints: {
            tuning: {
                isSuspectedORD: "Used to identify endpoints that look like ORDs regardless of current mPassEnabled setting./nUsed in tuning rules to identify endpoints that look like they should be configured as ORDs.\nConfigure MIN_DOWNLINK_DIRECT_ROUTE_SS and DIRECT_ROUTE_DAYS to adjust when this flag is set.",
                capabilityState: "Calculated during tuning.\nUNKNOWN when communicationMode (AMI flag) is unknown and the firmware version supposrt AMI.\nCONFIGURABLE when a tunable endpoint, has life cycle state of installed, inventory, not assigned; communication state is not removed; not in extend power fail, and doesn't have hardware read failures.\nREAD_PINGS if in read management meters.\nNONE if communicationMode is opt out or on demand or didn't meet other states.",
                lastCalculatedTuningGroup: "At the time of the last tuning chain job run, this was the tuning group who's TARGET configuration match this endpoints current configuration. This only represents the endpoint’s current config and does NOT create any future tuning changes. This field is not available in NMS.",
                minReadHistoryMinutes: "Minimum history depth in minutes used in last tuning. Computed during NA tuning chain run from the read history depth. ESM adjusted for 13FSK current/target modulation.",
                maxReadGapMins: "Largest timespan in minutes between 2 read messages during READ_ANALYSIS_DAYS. Only a gap if it is large than 2 * radio transmit rate. Computed during NA tuning chain run from read history. lastPerformanceEvent will reset the history depth. ESM looks at NORMAL msgs, Non esm NORMAL, BOOST, REPEATED.",
                readChanceOfFailure: "0 to 100 percent chance that we will miss reads in MAL period. Calculated by 1 minus the sum of throughputs raise to the transmitsPerMAL. Computed during NA tuning chain run. The Maximum Allowable Latency (MAL) time period is configured in each tuning rule criteria. The target transmits per MAL is defined in the rule action.",
                readNormalThroughput: "Number of received normal reads / Number of expected normal reads. The radio's transmit operational mode defines the number of expected read during the READ_ANALYSIS_DAYS or lastPerformanceEventDate. Computed during NA tuning from reads.",
                historyDepthMins: "Weighted moving average of daily read sample history average over READ_ANALYSIS_DAYS for this radio at the time of the last tuning chain run. Moving average calculated from daily average: readHistorySampleCountTotal/readHistorySampleMsgCountTotal * the radio's sample rate using smoothingFactorHistoryDepth. For performance and to have a single consistent calculation, this is intentionally different from the multiple ways NMS calculated this value.",
                isTempORD: "An endpoint that has buddy routes (it was in an ORD report) and fullMPASS = false"
            },
            tuningBestUplinkTower:{
                averageSS: "7 day average of this endpoint’s signal strength to the base station for the uplink channel.",
                averageSNR: "7 day average of this endpoint’s signal minus the 7 day average of noise on the base station for the uplink channel.",
                tuningBestTowerUplink: "Base station that heard this endpoint with the best tuning SNR.",
                tuningNoise: "7 day average SNR minus 7 day average Signal Strength."
            },
            tuningOption: {
                SYSTEM_TUNED: "I want NCS to manage this endpoint - suggest targets and reconfigure.",
                MANUAL_TUNED: "I want to manually manage tuning targets but have NCS perform the reconfigurations.",
                SYSTEM_SUGGEST: "I want to see the tuning targets NCS would select for this endpoint, but do not want NCS to perform the reconfiguration."
            },
            communicationState: "Field updated by a job that looks at multiple other fields.\nNot heard when lastHeard is null.\nNewly Heard when firstHeard is newer than 168 hours.\nRemoved when lastHeard is older than 720 hours.\nActive when firstHeard is between 720 and 168 hours old.\nPower failed when powerFailAlarmActive is true and the start date is newer than 168 hours, older than 168 hours it is removed. The 168 and 720 may be configured by highly permissioned users.",
            NA:{
                routeCount: "Number of routes used by the radio yesterday. Computed during the daily routes job."
            },
            Arqiva: {
                routeCount: "Number of routes used by the radio the last time the radio was heard within 10 days ({purgeDate}). Computed during the daily routes job."
            }
        },
        RapidTuneSweepTime: "Average Sweep Time",
        expectedStaticRebroadcaster: "Expected Static Rebroadcaster",
        expectedmPassBuddyRepeatEnabled: 'Expected mPass Buddy Repeat',
        expectedFullMPassMode: 'Expected Full MPass Mode',
        expectedLowPowerEnabled: 'Expected Low Power Enabled',
        expectedTransmitterEnabled: 'Expected Transmitter Enabled',
        expectedTransmitOperationalMode: 'Expected Transmit Operational Mode',
        expectedReceiveOperationalMode: 'Expected Receive Operational Mode',
        expectedChannelPairId: 'Expected Channel Pair ID',
        expectedColumnNotSortable: 'This column is not sortable as the data is calculated on the server instead of being a database field',
        run1: "Run 1",
        run2: "Run 2",
        need2TuningRuns: "There has only been 1 tuning run so far, please until another run happens before comparing tuning runs"
    },
    deviceTypes: {
        0: "0 - Transmit Only iCon Electric Meter",
        1: "1 - Transceiver iCon Electric Meter",
        2: "2 - GPS Testing Device",
        3: "3 - Water Meter",
        4: "4 - TGB RF Card",
        5: "5 - Elster A3 C&I FlexNet Radio",
        6: "6 - FlexNet Water Meter",
        7: "7 - FlexNet Gas",
        8: "8 - iCon Integrated Display",
        9: "9 - APX Integrated Display",
        10: "10 - Handheld",
        11: "11 - Buddy Box",
        12: "12 - Copper Fault Current Indicator",
        13: "13 - ZigBee Gateway",
        14: "14 - Canon Multi-Utility",
        15: "15 - Poletop Repeater",
        16: "16 - Thermostat",
        17: "17 - Propane Sensor",
        18: "18 - L&G Focus AL Energy Only FlexNet Radio",
        19: "19 - L&G Focus AX Time of Use",
        20: "20 - Aclara I-210+C Time of Use Radio with MSP430F5437",
        21: "21 - Aclara I-201+ Energy Only",
        22: "22 - APX Integrated Display with Zigbee",
        23: "23 - iConA TOU Integrated Display",
        24: "24 - iConA Zigbee Module with MSP430F5438",
        25: "25 - Thumb Buddy Box",
        26: "26 - EOL Thumb Buddy Box",
        27: "27 - FlexNet Network Portal (FNP)",
        28: "28 - In-Home Display",
        29: "29 - iConA TOU Metrology Processor",
        30: "30 - iCon AP Metrology Processor",
        31: "31 - iCon APX Metrology Processor",
        32: "32 - Elster A3 Metrology Processor",
        33: "33 - iCon Integ. Disp w/ AMI FW DL",
        34: "34 - Elster A3 C&I with 512KB Flash",
        35: "35 - Load Shed Box",
        36: "36 - Cooper Serial",
        37: "37 - FlexNet Remote Portal",
        38: "38 - L&G AL_kWh/L&G_AX_TOU",
        39: "39 - EOL FMT",
        40: "40 - FlexNet Metpod",
        41: "41 - miniFNP",
        42: "42 - L+G S4e FlexNet Radio",
        43: "43 - L+G S4e Metrology Processor",
        44: "44 - L+G Focus AX Metrology Processor",
        45: "45 - Blue Tooth Micro Transceiver",
        46: "46 - CommandLink (PHIT)",
        47: "47 - North American 2-Way Water",
        48: "48 - North American 2-Way Gas",
        49: "49 - Elster A3 C&I FlexNet Radio (with MSP430F5437)",
        50: "50 - iConAS TOU Integrated Display",
        51: "51 - L&G Focus AX FlexNet Radio (with MSP430F5437)",
        52: "52 - iConAS TOU Metrology Processor",
        53: "53 - Distribution Automation (Generic Transceiver)",
        54: "54 - U-SNAP Radio (with MSP430F5437)",
        55: "55 - Aclara kV2c Radio",
        56: "56 - Aclara kV2c Metrology Processor",
        57: "57 - Honeywell A3 Alpha",
        58: "58 - NA2W Gas Shutoff Valve",
        59: "59 - iConAS 400MHz",
        60: "60 - PRI Comms Module",
        61: "61 - PRT i-Credit 500 Meter",
        62: "62 - FMT USB",
        63: "63 - MLC or SLC Radio",
        64: "64 - NA2W Water Shutoff Valve",
        65: "65 - TGB PA Controller",
        66: "66 - Sensus iCon APX C& with MSPF430F537",
        67: "67 - Aclara SM112 400MHz FlexNet Radio",
        68: "68 - NA2W Three Port Gas Corrector",
        69: "69 - USNAP2 (with MSP430F5437)",
        70: "70 - L+G Zigbee Module with MSP450F5438",
        71: "71 - Zigbee End Device",
        72: "72 - Liberty Gas (400MHz with integrated shutoff)",
        73: "73 - 400MHz standalone Gateway",
        74: "74 - Low-power FlexNet radio module for Gateway",
        75: "75 - Zigbee radio module for Gateway",
        76: "76 - Elster Zigbee Module",
        77: "77 - EDMI MK7 FlexNet Radio",
        78: "78 - Combo Bluetooth/USB FMT (with MSP430F5437)",
        79: "79 - EDMI MK7B ESI",
        80: "80 - EDMI MK7B Meter",
        81: "81 - High Power Load Control Module Radio",
        82: "82 - High Power FlexNet Gateway Radio",
        83: "83 - iConAS Enhanced Radio (CC1120 with MSP430F5437)",
        84: "84 - Han Serial 3rd Party Device",
        85: "85 - 3rd Party Zigbee ESI",
        86: "86 - Sensus Lighting Control (SLC) Radio",
        87: "87 - EDMI MK7 Enhanced Radio (CC1125 with MSP430F5437)",
        88: "88 - EDMI 1-CAN",
        89: "89 - Water Register",
        90: "90 - L+G Focus AX FlexNet Enhanced Radio (CC1120 with MSP430F5437)",
        91: "91 - Multi-FMT",
        92: "92 - UK-Comms Hub NXP-SDK",
        93: "93 - R100E Repeater",
        94: "94 - UK-Comms Hub NXP-SDK-Fylingdales",
        95: "95 - iPerl Hat",
        96: "96 - StratusIQ with NXP K24 ARM Processor",
        97: "97 - StratusIQ with NXP KV31 ARM Processor",
        98: "98 - NextGen Zigbee Module with EM359x",
        99: "99 - Wireless Water Register",
        100: "100 - GE i210 Metrology Processor",
        101: "101 - Raw Metrology",
        102: "102 - Battery Endpoint",
        103: "103 - PHIT II",
        104: "104 - Cathodic Protection Metrology",
        105: "105 - Aclara i210 NextGen Radio with Freescale K22 ARM Processor",
        106: "106 - CP Mains Endpoint",
        107: "107 - CP Rectifier Monitor",
        108: "108 - Sensus Tool",
        109: "109 - Aclara kV2c NextGen Radio with Freescale K22 ARM Processor",
        110: "110 - Honeywell A3 Alpha",
        111: "111 - DA RTM FlexNet Radio Module",
        112: "112 - R100NA Repeater",
        113: "113 - R10NA Repeater",
        114: "114 - FlexModem",
        115: "115 - Gas Register",
        116: "116 - iPERL ASIC",
        117: "117 - Line Powered VantagePoint Radio",
        118: "118 - Line Powered VantagePoint Meter",
        119: "119 - NetGen LCM with K24",
        120: "120 - Cellular Modem",
        121: "121 - StratusIQ FlexNet with STM32 ARM Processor",
        122: "122 - StratusIQ Metrology with STM32 ARM Processor",
        123: "123 - GE kV2c NextGen Radio with STM32 ARM Processor",
        124: "124 - Stratus Evolve FlexNet",
        125: "125 - Stratus Evolve Metrology",
        UNKNOWN: "Unknown",
        null: "Not Set"
    },
    deviceTypeCategories: {
        oneWayWaterMeters: 'One Way Water Meters',
        badMetrologyMeters: 'Bad Metrology Meters',
        elsterMeters: 'Elster Meters',
        na2wLightingMeters: 'Na2w Lighting Meters',
        tunableMeters: 'Tunable Meters',
        lightingEndpoints: 'Lighting Endpoints',
        electricCommercialMeters: 'Electric Commercial Meters',
        waterMeters: 'Water Meters',
        lgMeters: 'LG Meters',
        gasMeters: 'Gas Meters',
        na2wShutoffValves: 'Na2w Shutoff Valves',
        slottedPollResponseDevices: 'Slotted Poll Response Devices',
        compulsoryRepeaters: 'Compulsory Repeaters',
        oneWayGasMeters: 'OneWay Gas Meters',
        electricMeters: 'Electric Meters',
        na2wWaterGasMeters: 'Na2w Water Gas Meters',
        electricResidentialMeters: 'Electric Residential Meters',
        readManagementMeters: 'Read Management Meters'
    },
    locationStatus: {
        INVALID_COORDINATES: "Invalid Lat/Lng",
        VALID_COORDINATES: "Valid Lat/Lng",
        ZERO_ZERO_COORDINATES: "0,0 Lat/Lng",
        null: "Not Set"
    },
    utilityTypes: {
        ELECTRIC: "Electric",
        ONE_WAY_GAS: "One-Way Gas",
        GAS: "Two-Way Gas",
        INFRASTRUCTURE: "Infrastructure",
        LIGHTING: "Lighting",
        ONE_WAY_WATER: "One-Way Water",
        WATER: "Two-Way Water",
        UNKNOWN: "Unknown",
        null: "Not Set"
    },
    routeCountValues: {
        0: "0",
        1: "1",
        MULTIPLE: "2+"
    },
    tuningFilterValues: {
        deviceType: {
            92: "92 - UK-Comms Hub NXP-SDK",
            93: "93 - R100E Repeater",
            94: "94 - UK-Comms Hub NXP-SDK-Fylingdales"
        }
    },
    setupReasons : {
        null: "Any Reason"
    },
    rapidTuneStatus: 'Rapid Tune Status',
    rapidTuning: {
        rapidTuningConfiguration: 'Rapid Tuning Configuration',
        updateRapidTuningConfig: 'Update Rapid Tuning Config'
    }
}
